import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

const $http = new APIManager();

const Api = {
  /**
   * [GETS] AlimTalkTemplate
   * --
   */
  getAlimTalkTemplates: async (params) => {
    try {
      const res = await $http.get(APIConstant.GETS_ALIM_TALK_TEMPLATE, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] AlimTalkTemplate
   * --
   */
  getAlimTalkTemplate: async (idx, params) => {
    try {
      const url = parameterToPath(APIConstant.GET_ALIM_TALK_TEMPLATE, {
        alim_talk_template_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] AlimTalkTemplate
   * --
   */
  createAlimTalkTemplate: async (body) => {
    try {
      const res = await $http.post(APIConstant.CREATE_ALIM_TALK_TEMPLATE, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] AlimTalkTemplate
   * --
   */
  updateAlimTalkTemplate: async (body) => {
    try {
      const { alim_talk_template_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_ALIM_TALK_TEMPLATE, {
        alim_talk_template_id: alim_talk_template_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] AlimTalkTemplate
   * --
   */
  deleteAlimTalkTemplate: async (idx) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_ALIM_TALK_TEMPLATE, {
        alim_talk_template_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
